import React from "react"
import { Route } from "react-router-dom"
import SetLanguage from "../shared/SetLanguage"

class PublicRoutesRoute extends React.Component {
	render() {
		const { component: Component, isAuthenticated, ...props } = this.props
		return (
			<Route
				{...props}
				render={(props) => (
					<div>
						<SetLanguage />
						<Component {...this.props} />
					</div>
				)}
			/>
		)
	}
}

export default PublicRoutesRoute



// WEBPACK FOOTER //
// ./src/views/components/routes/PublicRoutesRoute.js